module.exports = __webpack_public_path__ + "static/media/sucess-pay.302d44b9.svg";